import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { applyDocumentMetadata, resolveRouteMetadata } from '../../seo/routeMetadata';
import { applyDocumentSchemas, resolveRouteSchemaDocuments } from '../../seo/schemaRuntime';
import { getSeoRuntimeFlags } from '../../seo/runtimeFlags';

function getSafeRuntimeFlags() {
  try {
    if (typeof getSeoRuntimeFlags === 'function') {
      return getSeoRuntimeFlags();
    }
  } catch (_err) {
    // Fall through to safe defaults to avoid a client crash during HMR/intermediate builds.
  }

  return {
    seoRuntimeEnabled: true,
    metadataEnabled: true,
    schemaEnabled: true,
  };
}

const RouteMetadataManager = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const flags = getSafeRuntimeFlags();
    if (!flags.seoRuntimeEnabled) return;
    if (!flags.metadataEnabled && !flags.schemaEnabled) return;

    const meta = resolveRouteMetadata({
      pathname: location.pathname,
      search: location.search,
      hostname: window.location.hostname,
    });

    if (flags.metadataEnabled) {
      applyDocumentMetadata(meta);
    }

    if (flags.schemaEnabled) {
      const schemaDocuments = resolveRouteSchemaDocuments({
        pathname: location.pathname,
        meta,
      });
      applyDocumentSchemas(schemaDocuments);
    }
  }, [location.pathname, location.search]);

  return null;
};

export default RouteMetadataManager;
